import { extend } from '@syncfusion/ej2-base'
import { useMemo, useRef } from 'react'
import { type FingerprintableEvent, fingerprintScheduleEvent } from './fingerprintScheduleEvent'

const fingerprintEvents = (events: FingerprintableEvent[]): string =>
  events.map((event) => fingerprintScheduleEvent(event)).join(';')

export const useStableScheduleDataSource = <T extends FingerprintableEvent>(events: T[]): T[] => {
  const dataRef = useRef<T[]>([])
  const fingerprintRef = useRef('')

  return useMemo(() => {
    const fingerprint = fingerprintEvents(events)
    if (fingerprint === fingerprintRef.current) {
      return dataRef.current
    }

    fingerprintRef.current = fingerprint
    const previousById = new Map(dataRef.current.map((event) => [Number(event.id), event]))
    const next = events.map((event) => {
      const existing = previousById.get(Number(event.id))
      if (existing && fingerprintScheduleEvent(existing) === fingerprintScheduleEvent(event)) {
        return existing
      }
      return extend({}, event, null, true) as T
    })
    dataRef.current = next
    return next
  }, [events])
}
